import React from 'react';
import { JobTitlesGridProps } from '../interfaces';
import { JobTitleCard } from './JobTitleCard';

export const JobTitlesGrid = ({
  jobTitles,
  currentPage,
  itemsPerPage,
  searchQuery,
  onDelete,
}: JobTitlesGridProps) => {
  if (jobTitles.length === 0) {
    return (
      <div className='text-center py-16 text-gray-500 text-sm'>
        {searchQuery
          ? 'No job titles found matching your search.'
          : 'No job titles yet. Add one above!'}
      </div>
    );
  }

  return (
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 p-4'>
      {jobTitles.map((jobTitle, index) => (
        <JobTitleCard
            key={jobTitle.value}
            jobTitle={jobTitle}
            index={index}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onDelete={onDelete}
        />
      ))}
    </div>
  );
};
